import React, { useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import { FormattedNumber, formattedNumber } from "../../FormattedNumber/FormattedNumber";

import style from "./Chart.scss";

const colors = {
  1: "color1",
  2: "color2",
  3: "color3",
  4: "color4",
  5: "color5",
  6: "color6",
};

const riskColors = {
  1: "riskColor1",
  2: "riskColor2",
  3: "riskColor3",
  4: "riskColor4",
  5: "riskColor5",
  6: "riskColor6",
};

export const AssetClassDoghnut = ({ position, onSelectItem }) => {
  const [chartOptions, setChartOptions] = useState({});

  const tooltipFormatter = (param) => {
    return `Composición por tipo de instrumento <br/><span style="color: ${param.color}">●</span> ${
      param.data.name
    }: <span style="font-weight: bold">${formattedNumber(param.value)}</span>`;
  };

  useEffect(() => {
    if (position.assetClass.length) {
      const optionData = position.assetClass.map((assetClassItem) => ({
        name: assetClassItem.name,
        value: +assetClassItem.total,
        items: assetClassItem.subAssetClass,
      }));

      let option = {
        title: {
          text: "Composición por tipo de instrumento",
          left: "center",
          top: 0,
          textStyle: {
            fontFamily: "Arial",
            overflow: "break",
            width: screen.width < 400 ? screen.width - 100 : 300,
          },
        },
        legend: {
          orient: "vertical",
          left: 0,
          top: 40,
          show: screen.width > 1200 ? true : false,
          textStyle: {
            fontFamily: "Arial",
            overflow: "break",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: tooltipFormatter,
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "90%"],
            data: optionData,
            left: screen.width < 1200 ? 0 : 50,
            top: 50,
            label: {
              show: false,
            },
            color: ["#a3dcf7", "#11658d", "#1996d5", "#0d4664"],
          },
        ],
        renderer: "svg",
      };

      setChartOptions(option);
    }
  }, [position]);

  const onEvents = {
    click: onSelectItem,
  };

  return (
    <div className={style.doghnutWrapper}>
      <ReactEcharts option={chartOptions} onEvents={onEvents} />
    </div>
  );
};

export const SubAssetClassDoghnut = ({ subAssetClasses }) => {
  const [chartOptions, setChartOptions] = useState({});

  const tooltipFormatter = (param) => {
    return `Composición por instrumento <br/><span style="color: ${param.color}">●</span> ${
      param.data.name
    }: <span style="font-weight: bold">${formattedNumber(param.value)}</span>`;
  };

  useEffect(() => {
    if (subAssetClasses.length) {
      const optionData = subAssetClasses.map((subAssetClassesItem) => ({
        name: subAssetClassesItem.name,
        value: +subAssetClassesItem.total,
      }));

      let option = {
        legend: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: tooltipFormatter,
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "100%"],
            height: 150,
            data: optionData,
            emphasis: {
              disabled: true,
            },
            label: {
              show: false,
            },
            color: ["#3B82F6", "#22C55E", "#F43F6C", "#71717A", "#20D3A4", "#F59E0B"],
          },
        ],
        renderer: "svg",
      };

      setChartOptions(option);
    }
  }, [subAssetClasses]);

  return (
    <div className={style.doghnutWrapper}>
      <ReactEcharts option={chartOptions} />
    </div>
  );
};

export const SubAssetClassDoghnutItems = ({ subAssetClasses }) => {
  let pillColorIdx = 0;
  return (
    <div className={style.legendWrapper}>
      {subAssetClasses.map((item, index) => {
        if (pillColorIdx === 6) {
          pillColorIdx = 1;
        }
        pillColorIdx += 1;

        return (
          <span className={style.legendItem} key={item.name + "-" + index}>
            <span className={style[colors[pillColorIdx]]}>●</span>
            <span className={style.name}>{item.name}</span>
          </span>
        );
      })}
    </div>
  );
};

export const AssetsRisksDoghnut = ({ assets = [], portfolioTotal }) => {
  const [chartOptions, setChartOptions] = useState({});

  const tooltipFormatter = (param) => {
    return `Calificación de riesgo <br/><span style="color: ${param.color}">●</span> ${
      param.data.name
    }: <span style="font-weight: bold">${formattedNumber(param.value)}</span>`;
  };

  useEffect(() => {
    if (assets.length) {
      let totalAssets = 0;
      assets.map((asset) => {
        totalAssets += parseFloat(asset.totalUSDWithCoupon);
      });

      let risks = [];
      assets.map((asset) => {
        if (!risks[asset.riskType]) {
          risks[asset.riskType] = {
            value: 0,
            name: asset.riskType,
          };
        }

        risks[asset.riskType].value += (+asset.totalUSDWithCoupon * 100) / +totalAssets;
      });

      const optionData = Object.values(risks).map((risk) => ({
        name: risk.name,
        value: Math.round(risk.value * 100) / 100,
      }));

      // const optionData = assets.map((Asset) => ({
      //   name: Asset.riskType,
      //   value: (+Asset.totalUSDWithCoupon * 100) / +portfolioTotal,
      // }));

      let option = {
        legend: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: tooltipFormatter,
        },
        series: [
          {
            type: "pie",
            minAngle: 5,
            radius: ["60%", "100%"],
            height: 157,
            data: optionData,
            emphasis: {
              disabled: true,
            },
            label: {
              show: false,
            },
            color: ["#3B82F6", "#22C55E", "#F43F6C", "#71717A", "#20D3A4", "#F59E0B"],
          },
        ],
        renderer: "svg",
      };

      setChartOptions(option);
    }
  }, [assets]);

  return (
    <div className={style.doghnutWrapper}>
      <ReactEcharts option={chartOptions} />
    </div>
  );
};

export const AssetRiskList = ({ assets = [], portfolioTotal }) => {
  const [riskList, setRiskList] = useState([]);

  useEffect(() => {
    let totalAssets = 0;
    assets.map((asset) => {
      totalAssets += parseFloat(asset.totalUSDWithCoupon);
    });

    let risks = [];
    assets.map((asset) => {
      if (!risks[asset.riskType]) {
        risks[asset.riskType] = {
          value: 0,
          name: asset.riskType,
        };
      }

      risks[asset.riskType].value += (+asset.totalUSDWithCoupon * 100) / +totalAssets;
    });

    const newList = Object.values(risks).map((risk) => {
      const name = risk.name;
      const value = risk.value;

      return {
        name,
        value,
        width: value + 50,
      };
    });

    setRiskList(newList);
  }, []);

  let pillColorIdx = 0;

  return (
    <div className={style.riskList}>
      <ul>
        {riskList.map((risk) => {
          if (pillColorIdx === 6) {
            pillColorIdx = 1;
          }
          pillColorIdx += 1;

          return (
            <li className={style.item}>
              <span className={style.riskListItem}>
                <span className={style.name}>{risk.name}</span>
                <span
                  className={`${style.value} ${style[riskColors[pillColorIdx]]}`}
                  style={{ width: risk.width }}
                >
                  <FormattedNumber value={risk.value} minimumFractionDigits={2} maximumFractionDigits={2} />%
                </span>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export const PortfolioDoghnut = ({ portfolio }) => {
  const [chartOptions, setChartOptions] = useState({});

  const tooltipFormatter = (param) => {
    return `Portafolio <br/><span style="color: ${param.color}">●</span> ${
      param.data.name
    }: <span style="font-weight: bold">${formattedNumber(param.data.valueOriginal)}</span>`;
  };

  useEffect(() => {
    if (portfolio) {
      const optionData = [];
      optionData.push({
        name: "Total USD",
        value: +portfolio.position.valueTotalUSD,
        valueOriginal: +portfolio.position.valueTotal,
      });
      optionData.push({
        name: "Total Gs",
        value: +portfolio.positionPYG.valueTotalUSD,
        valueOriginal: +portfolio.positionPYG.valueTotal,
      });

      let option = {
        title: {
          text: "Total portafolio",
          left: "center",
          top: 0,
          textStyle: {
            fontFamily: "Arial",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: tooltipFormatter,
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "90%"],
            data: optionData,
            top: 30,
            label: {
              show: false,
            },
            color: ["#a3dcf7", "#11658d", "#1996d5", "#0d4664"],
          },
        ],
        renderer: "svg",
      };

      setChartOptions(option);
    }
  }, [portfolio]);

  return (
    <div className={style.portfolioDoghnutWrapper}>
      <ReactEcharts option={chartOptions} />
    </div>
  );
};
